'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _BaseInput = require('react-jsonschema-form/lib/components/widgets/BaseInput');

var _BaseInput2 = _interopRequireDefault(_BaseInput);

var _utils = require('react-jsonschema-form/lib/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var badKeyCodes = [69, 101, 187, 188, 189, 190];

exports.default = function (props) {
  return _react2.default.createElement(_BaseInput2.default, (0, _extends3.default)({
    type: 'number',
    onKeyDown: function onKeyDown(event) {
      var keyCode = 'which' in event ? event.which : event.keyCode;

      if (badKeyCodes.indexOf(keyCode) !== -1) {
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }, props, (0, _utils.rangeSpec)(props.schema), {
    min: 0
  }));
};


//////////////////
// WEBPACK FOOTER
// ./~/form-service/frontend/lib/components/Overrided/widgets/UpDownWidget.js
// module id = 1122
// module chunks = 5